// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n[data-v-f8587160] .tabs-filled .nav-tabs li:nth-of-type(1) .nav-link:after {\n  content: \"Player Settings\";\n}\n[data-v-f8587160] .tabs-filled .nav-tabs li:nth-of-type(2) .nav-link:after {\n  content: \"Security\";\n}\n@media (max-width: 767px) {\n}\n\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
